import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DescriptionIcon from "@mui/icons-material/Description"; // For CSV
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { getFileIcon, getFileName } from "../../utils/getFileIcon";
import { getImageUrl } from "../../utils/common";

function DocumentItem({ url }) {
  const fileUrl = decodeURIComponent(url.split(".").pop());
  const fileName = getFileName(url);
  const isImage = ["png", "jpg", "jpeg"].includes(fileUrl);
  const [signedUrls, setSignedUrls] = useState("");

  const downloadFile = async (newUrl, fileName) => {
    try {
      const response = await fetch(newUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName; // ✅ works for all file types
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
      // fallback → just open in new tab if blob fails
      window.open(newUrl, "_blank");
    }
  };

  const handleDownload = async (url) => {
    let newUrl = await getImageUrl(url);

    // Extract filename properly, handling query parameters and encoded URLs
    let fileName;
    try {
      // First try to get filename from the original URL using getFileName utility
      fileName = getFileName(url);

      // If that doesn't work, fallback to extracting from the processed URL
      if (!fileName || fileName === "document.pdf") {
        const urlParts = newUrl.split("/");
        const lastPart = urlParts[urlParts.length - 1];
        fileName = lastPart.split("?")[0];
      }

      // Ensure we have a proper filename with extension
      if (!fileName || !fileName.includes(".")) {
        const fileExtension = fileUrl || "file";
        fileName = `document.${fileExtension}`;
      }
    } catch (error) {
      console.error("Error extracting filename:", error);
      fileName = `document.${fileUrl || "file"}`;
    }

    // For images and other files, we need to handle the download differently
    if (isImage) {
      // For images, we need to fetch the blob and create a download link
      const link = document.createElement("a");
      console.log("first1", link);
      link.href = newUrl;
      link.setAttribute("download", fileName); // ✅ forces download instead of opening
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else {
      // console.log("first", newUrl);
      // For non-image files, use direct download
      const link = document.createElement("a");
      link.href = newUrl;
      link.setAttribute("download", fileName);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // downloadFile(newUrl, fileName);
    }
  };

  const imageUrl = async (url) => {
    const imgUrl = await getImageUrl(url);
    setSignedUrls(imgUrl);
    return imgUrl;
  };
  useEffect(() => {
    imageUrl(url);
  }, [url]);
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        alignSelf: "flex-start",
        border: "1px solid #ddd",
        borderRadius: "4px",
        backgroundColor: isImage ? "transparent" : "#fff",
        width: isImage ? "auto" : "fit-content",
        maxWidth: "100%",
        minWidth: "100px",
      }}
    >
      {isImage ? (
        <img
          src={signedUrls}
          alt={fileName}
          style={{
            width: "100px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "30px",
            alignItems: "center",
            gap: 1,
            padding: 1,
            minWidth: 0,
            maxWidth: { xs: 220, sm: 280 },
          }}
        >
          {/* {isCsv ? (
            <DescriptionIcon sx={{ fontSize: "20px", color: '#1A73E8' }} />
          ) : isExcel ? (
            <FontAwesomeIcon icon={faFileExcel} style={{ fontSize: "17px",padding:1, color: '#0a8f08' }} />
          ) : (
            <DescriptionIcon sx={{fontSize: "20px", color: '#ccc' }} />
          )} */}
          {getFileIcon(fileUrl)}
          <Typography
            variant="caption"
            noWrap
            sx={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {fileName}
          </Typography>
        </Box>
      )}
      <IconButton
        onClick={() => handleDownload(url)}
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          color: "white",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "20px",
          height: "20px",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.7)",
          },
        }}
      >
        <ArrowDownwardIcon sx={{ width: "10px", height: "10px" }} />
      </IconButton>
    </Box>
  );
}

export default DocumentItem;
